<template>
  <NuxtLayout>
    <NuxtPage />
    <ClientOnly>
      <UNotifications />
    </ClientOnly>
  </NuxtLayout>
</template>

<script setup lang="ts">
/**
 * Разделы, которые не должны попадать в индекс: личный кабинет, админка,
 * оформление заказа и технические экраны.
 *
 * Дублирует правила robots.txt намеренно. Disallow запрещает только обход: если
 * на такой URL ведёт внешняя ссылка, поисковик всё равно может показать его в
 * выдаче. Мета-тег noindex убирает страницу из индекса гарантированно — но
 * только если робот её прочитал, поэтому нужны оба правила.
 *
 * Живёт здесь, а не в layouts/default.vue: админка рендерится в layout
 * `admin-kit`, а /ui-kit вообще с `layout: false` — до них лейаут витрины
 * не дотягивается, и они оставались с дефолтным «index, follow».
 */
const NOINDEX_PREFIXES = [
  '/administration',
  '/lk',
  '/profile',
  '/notifications',
  '/favorites',
  '/order',
  '/success',
  '/fail',
  '/reset-password',
  '/verifyEmail',
  '/logInYandex',
  '/ui-kit',
  '/mocks',
  '/debug',
]

const route = useRoute()

const isIndexablePage = computed(() =>
  !NOINDEX_PREFIXES.some(prefix => route.path === prefix || route.path.startsWith(`${prefix}/`)),
)

useHead(() => ({
  meta: [
    // ✅ Viewport с safe area (iOS/Android)
    {
      name: 'viewport',
      content: 'width=device-width, initial-scale=1.0, viewport-fit=cover',
    },
    {
      name: 'robots',
      content: isIndexablePage.value ? 'index, follow' : 'noindex, nofollow',
    },
  ],
}))
</script>
